import styled from "@emotion/styled";
import { PLANS_COMPONENT_WIDTH } from "constants/pricing-sizes";
export const StyledFeaturesTablePricingComponent = styled.div`
  width: ${`${PLANS_COMPONENT_WIDTH}px`};
  margin: 0 auto;
`;
